/* eslint-disable arrow-parens */
/* eslint-disable react/prop-types */
import { forwardRef, useCallback, useContext } from "react";
import { ThemeContext } from "../../../../contexts";

import {
	Button,
	TextField,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	DialogContentText,
	Slide,
	Grid,
	IconButton,
	TextareaAutosize
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import SendIcon from "@material-ui/icons/Send";

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});
const CustomAddNoteDialog = ({ dialogProps, handleClose, handleAddNewNoteChange, handleAddNoteSubmitClick }) => {
	const { openDialog, title, actions } = dialogProps;
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { theme } = useContext(ThemeContext);

	// const handleAddNewNoteChange = useCallback(
	// 	(event) => {
	// 		const { value } = event.target;
	// 		setAddNewNote(value);
	// 	},
	// 	[setAddNewNote]
	// );

	return (
		<Dialog
			style={{ zIndex: 5000 }}
			open={openDialog}
			onClose={handleClose}
			fullWidth
			maxWidth="xs"
			TransitionComponent={Transition}
			keepMounted
			aria-labelledby="alert-dialog-slide-title"
			aria-describedby="alert-dialog-slide-description"
		>
			<DialogTitle id="form-dialog-title">
				<div className="custom-dialog-title-with-icon-container">
					<span>{title}</span>
					<span>
						<IconButton aria-label="close" onClick={handleClose}>
							<CloseIcon fontSize="medium" />
						</IconButton>
					</span>
				</div>
			</DialogTitle>

			<DialogContent>
				<Grid container spacing={1} className=" pf-grid-container ">
					<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
						<TextareaAutosize
							minRows={6}
							placeholder="Add new note"
							defaultValue={""}
							style={{ width: "100%", padding: "1rem" }}
							onChange={(event) => handleAddNewNoteChange(event)}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				{actions.map((action, index) => {
					const { label, callback, name } = action;

					return (
						<Button
							className={
								name === "cancel"
									? "custom-dialog-action-button-grey"
									: "custom-dialog-action-button-green"
							}
							variant="contained"
							key={index}
							// onClick={() => {
							// 	callback();
							// }}
							onClick={name === "submit" ? handleAddNoteSubmitClick : callback}
						>
							<span className="custom-dialog-action-button-label-with-icon">{label}</span>
							<span>
								{name === "submit" ? (
									<SendIcon className="custom-dialog-action-button-icon" />
								) : (
									<CloseIcon className="custom-dialog-action-button-icon" />
								)}
							</span>
						</Button>
					);
				})}
			</DialogActions>
		</Dialog>
	);
};

export default CustomAddNoteDialog;
